export default "__VITE_ASSET__7Bh0iKrN__"